var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.49 20.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.7,16.92H.8a.81.81,0,0,1-.6-1.34L1,14.7a2.45,2.45,0,0,0,.62-1.63V2.83A2.83,2.83,0,0,1,4.45,0h10.9a.8.8,0,0,1,.73.47.78.78,0,0,1-.13.85l-.83,1a2.47,2.47,0,0,0-.59,1.6V14.09A2.83,2.83,0,0,1,11.7,16.92Zm-9.16-1.6H11.7a1.23,1.23,0,0,0,1.23-1.23V3.88a4,4,0,0,1,.7-2.28H4.45A1.23,1.23,0,0,0,3.22,2.83V13.07A4.1,4.1,0,0,1,2.54,15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,20.18H4.14a.8.8,0,0,1-.6-1.33l.8-.88a.79.79,0,0,1,1.13-.06.83.83,0,0,1,.26.67H15a1.23,1.23,0,0,0,1.23-1.22V7.15A4,4,0,0,1,17,4.87h-.26a.8.8,0,0,1,0-1.6h2a.8.8,0,0,1,.73.47.78.78,0,0,1-.13.85l-.83,1a2.45,2.45,0,0,0-.59,1.6V17.36A2.83,2.83,0,0,1,15,20.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.73,5.82H6A.8.8,0,1,1,6,4.23H9.73a.8.8,0,1,1,0,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.73,9.26H6a.8.8,0,1,1,0-1.6H9.73a.8.8,0,1,1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,12.69H6a.8.8,0,0,1,0-1.6H7a.8.8,0,0,1,0,1.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubMenu);
export default __webpack_public_path__ + "static/media/SubMenu.09495199de807bf2da2f02b4dba5df20.svg";
export { ForwardRef as ReactComponent };